import d3 from 'd3'

export const showOriginalText = () => {
  let iframe = d3.select('iframe.goog-te-banner-frame').node()
  iframe && d3.select(iframe.contentDocument)
    .selectAll('.goog-te-button button').each(function() {
      if(this.innerHTML === 'Show original')
        this.click()
    })
}

// Google Translate Options
let languages = [
  {
      key: 'en',
      text: 'English',
      value: 'en'
  },
  {
      key: 'fr',
      text: 'French',
      value: 'fr'
  },
  {
      key: 'de',
      text: 'German',
      value: 'de'
  },
  {
      key: 'ja',
      text: 'Japanese',
      value: 'ja'
  },
  {
      key: 'id',
      text: 'Indonesian',
      value: 'id'
  },
  {
      key: 'es',
      text: 'Spanish',
      value: 'es'
  },
  {
      key: 'ar',
      text: 'Arabic',
      value: 'ar'
  },
  {
      key: 'my',
      text: 'Myanmar (Burmese)',
      value: 'my'
  },
  {
      key: 'zh-TW',
      text: 'Chinese (Traditional)',
      value: 'zh-TW'
  },
  {
      key: 'th',
      text: 'Thai',
      value: 'th'
  },
  {
      key: 'ms',
      text: 'Malay',
      value: 'ms'
  },
  {
      key: 'tl',
      text: 'Filipino',
      value: 'tl'
  }
].sort((a,b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0))

export const translateOptions=[
  {
    key: 'or',
    text: 'Original Language',
    value: 'or'
},
...languages
]

const langCode = {
  'en': 'English',
  'de': 'German',
  'fr': 'French',
  'ja': 'Japanese',
  'id': 'Indonesian',
  'es': 'Spanish',
  'ar' : 'Arabic',
  'my': 'Myanmar (Burmese)',
  'zh-TW' : 'Chinese (Traditional)',
  'th' : 'Thai',
  'ms' : 'Malay',
  'tl' : 'Filipino'
}

export const changeLanguage = (lang) => {
  setCookie('googtrans', lang, 1, window.location.hostname)
  if(d3.select('iframe.goog-te-menu-frame').node())
    d3.select((d3.select('iframe.goog-te-menu-frame').node().contentDocument))
      .selectAll('.goog-te-menu2-item span.text')
      .each(function() {
        if(this.innerHTML === langCode[lang]) {
          this.click()
        }
      })
}

const setCookie = (cname, cvalue, exdays, domain) => {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires + ";domain=" + domain + ";path=/";
}

export const clearTranslate = () => {
  setCookie('googtrans', null, 1, "");
}
